import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col, Modal } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Countries from "../assets/countriesJSON/countries.json";
import { ThreeDots } from "react-loader-spinner"; // Import the loader
import jsPDF from "jspdf";

const baseUrl = process.env.REACT_APP_API_URL;

const ContactSalesForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const providerDetails = location.state?.providerDetails || "";

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    company: "",
    city: "",
    state: "",
    zipcode: "",
    country: "",
    message: "",
    Interested_in: [],
    //providerDetails: providerDetails ? [{ id: providerDetails, sendDetailsToProvider: false,  geometry_file_url: '' }] : [{ id: '1874ccbdfcde84b657b02423ec836f4b', sendDetailsToProvider: false,  geometry_file_url: '' }], // Update to object format
    providerDetails: providerDetails
      ? [
          {
            id: providerDetails,
            sendDetailsToProvider: false,
            geometry_file_url: "",
          },
        ]
      : [
          {
            id: "c079ff1d7dbd6b2b11e289655bb78e27",
            sendDetailsToProvider: false,
            geometry_file_url: "",
          },
        ], // Update to object format
    terms_and_conditions: false,
  });

  const [responseMessage, setResponseMessage] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showTermsModal, setShowTermsModal] = useState(false); // For modal popup
  const [showError, setShowError] = useState(false); // To show error when terms not accepted
  const [countdown, setCountdown] = useState(5);

  const interestOptions = [
    "Drone imagery collection",
    "LiDAR data collection",
    "Thermal data collection",
    "Solar Panel Inspection",
    "Wind turbine Inspection",
    "Power line inspection and monitoring",
    "Pipeline inspection and monitoring",
    "Mining Inspection",
    "Building Inspection",
    "Bridge Inspection",
    "Confined space Industrial drone Inspection",
    "Construction site inspection and monitoring",
    "Rail road inspection and monitoring",
    "Others",
  ];

  useEffect(() => {
    const kmlResponseUrl = localStorage.getItem("kmlResponseUrl");
    if (kmlResponseUrl) {
      setFormData((prevData) => {
        const updatedproviderDetails = prevData.providerDetails.map(
          (provider) => ({
            ...provider,
            geometry_file_url: kmlResponseUrl,
          })
        );
        return { ...prevData, providerDetails: updatedproviderDetails };
      });
    }
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prevData) => {
      if (checked) {
        return {
          ...prevData,
          Interested_in: [...prevData.Interested_in, value],
        };
      } else {
        return {
          ...prevData,
          Interested_in: prevData.Interested_in.filter(
            (interest) => interest !== value
          ),
        };
      }
    });
  };

  const handleTermsChange = (e) => {
    setFormData({ ...formData, terms_and_conditions: e.target.checked });
    setShowError(false); // Hide error when user checks the box
  };

  const handleSendDetailsChange = (e) => {
    const { checked } = e.target;

    // If providerEmails array exists, update the first element with the checkbox value
    if (formData.providerDetails.length > 0) {
      const updatedproviderDetails = formData.providerDetails.map(
        (provider) => ({
          ...provider,
          sendDetailsToProvider: checked,
        })
      );

      setFormData({ ...formData, providerDetails: updatedproviderDetails });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.terms_and_conditions) {
      setShowError(true); // Show error if terms are not accepted
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await fetch(`${baseUrl}/customer`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setResponseMessage("Form submitted successfully!");
        setFormSubmitted(true);
        window.scrollTo(0, 0);
      } else {
        setResponseMessage(
          result.message || "An error occurred while submitting the form."
        );
      }
    } catch (error) {
      setResponseMessage("Failed to submit the form.");
      console.error("Error:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (formSubmitted && countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else if (formSubmitted && countdown === 0) {
      navigate("/");
    }
  }, [formSubmitted, countdown, navigate]);

  const downloadPDF = () => {
    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text("Terms of Service", 20, 20);

    // Terms content
    const termsText = [
      `Effective Date: October 17, 2024

1. Introduction

Welcome to GeoWGS84 Corp ("GeoWGS84," "we," "us," or "our"). By accessing or using our services, including our website, software, and any related products or services (collectively, the "Services"), you agree to comply with and be bound by these Terms of Service ("Terms"). Please read these Terms carefully before using our Services. If you do not agree to these Terms, you may not use our Services.

2. Services

GeoWGS84 provides geospatial data, mapping solutions, and related services to our clients ("Client" or "you"). The specifics of the Services we provide will be detailed in individual agreements or contracts with our clients.

3. Use of Services

- Eligibility: To use our Services, you must be at least 18 years old and capable of forming a legally binding contract. By using our Services, you represent and warrant that you meet these requirements.

- Account Responsibilities: You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Notify us immediately if you become aware of any unauthorized use of your account.

- Permitted Use: You agree to use our Services only for lawful purposes and in accordance with these Terms. You may not use our Services for any illegal or unauthorized activities, including but not limited to violating intellectual property rights or transmitting harmful or disruptive content.

4. Intellectual Property

- Ownership: All intellectual property rights in and to the Services, including but not limited to software, designs, logos, and content, are owned by GeoWGS84 or its licensors. You may not copy, modify, distribute, or create derivative works based on our intellectual property without our prior written consent.

- License: Subject to your compliance with these Terms, we grant you a limited, non-exclusive, non-transferable license to use our Services for your personal or internal business purposes.

5. Fees and Payment

- Fees: The fees for our Services will be outlined in individual agreements or contracts. You agree to pay all fees as specified and in accordance with the payment terms agreed upon.

- Payment Terms: Payments are due in accordance with the terms specified in the applicable agreement or contract. Late payments may incur interest and collection fees.

6. Termination

- Termination by You: You may terminate your use of our Services at any time by providing us with written notice.  If a contract is in place you are obligated to the contract and cannot terminate it without an agreement with GeoWGS84.

- Termination by Us: We reserve the right to terminate or suspend your access to our Services, with or without cause, at our sole discretion. If we terminate your access for breach of these Terms, we may retain any fees paid.

7. Limitation of Liability

To the fullest extent permitted by law, GeoWGS84 shall not be liable for any indirect, incidental, special, or consequential damages arising out of or in connection with your use of our Services, including but not limited to loss of profits, data, or goodwill.
All data acquired and processed will be the responsibility of GeoWGS84 business partners.  Our business partners are responsible for meeting the project specifications for data collection and processing and turnaround times.

8. Indemnification

You agree to indemnify, defend, and hold harmless GeoWGS84 and its affiliates, officers, directors, employees, and agents from and against any claims, liabilities, damages, losses, or expenses arising out of or related to your use of our Services, your violation of these Terms, or your infringement of any third-party rights.

9. Changes to Terms

We may modify these Terms from time to time. We will notify you of any material changes by posting the updated Terms on our website. Your continued use of our Services after such changes constitutes your acceptance of the revised Terms.

10. Governing Law

These Terms shall be governed by and construed in accordance with the laws of the State of Colorado, without regard to its conflict of law principles. Any disputes arising under or in connection with these Terms shall be resolved exclusively in the courts located in Colorado.

11. Contact Us

If you have any questions or concerns about these Terms, please contact us at:

GeoWGS84 Corp  
11973 S Longs Bluff Ln	
Parker, CO, 80134
(720) 702-4849
info@geowgs84.com

-------------------

12. Miscellaneous

- Entire Agreement: These Terms constitute the entire agreement between you and GeoWGS84 regarding your use of our Services and supersede all prior agreements and understandings.

- Severability: If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions will remain in full force and effect.

- No Waiver: Our failure to enforce any right or provision of these Terms will not be deemed a waiver of such right or provision.

Thank you for choosing GeoWGS84 Corp!`,
    ];

    // Adding text to the PDF with wrapping
    doc.setFontSize(12);
    let yOffset = 30; // Initial vertical position
    const pageWidth = doc.internal.pageSize.getWidth() - 40; // Width with margins
    const pageHeight = doc.internal.pageSize.getHeight() - 20; // Height with margins

    termsText.forEach((line) => {
      // Split the text into lines that fit the page width
      const splitText = doc.splitTextToSize(line, pageWidth);
      splitText.forEach((textLine) => {
        // Check if we need to add a new page
        if (yOffset + 10 > pageHeight) {
          doc.addPage(); // Add a new page
          yOffset = 20; // Reset yOffset for the new page
        }
        doc.text(textLine, 20, yOffset);
        yOffset += 10; // Move down for the next line
      });
    });

    // Save the generated PDF file
    doc.save("TermsAndConditions.pdf");
  };

  return (
    <Container className="no-space-top page-container">
      <Row className="justify-content-center">
        <Col md={8}>
          {!formSubmitted ? (
            <>
              <div className="contact-form-container">
                <h1 className="text-center heading-blue">
                  Contact Our Sales Team
                </h1>
                <p className="text-center">
                  We offer drone services and welcome your inquiries. Please
                  complete the provided form, and we will respond to you
                  promptly.
                </p>
                <Form onSubmit={handleSubmit} className="contact-form">
                  <Row>
                    <Col md={6}>
                      <Form.Group controlId="firstName">
                        <Form.Control
                          type="text"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="Enter your first name"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="lastName">
                        <Form.Control
                          type="text"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Enter your last name"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group controlId="email" className="mt-3">
                    <Form.Control
                      type="text"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      required
                    />
                  </Form.Group>
                  <Form.Group controlId="company" className="mt-3">
                    <Form.Control
                      type="text" // Fixing type from 'company' to 'text'
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      placeholder="Enter your company (optional)"
                    />
                  </Form.Group>
                  <Row className="mt-3">
                    <Col md={6}>
                      <Form.Group controlId="city">
                        <Form.Control
                          type="text"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          placeholder="Enter your city"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="state">
                        <Form.Control
                          type="text"
                          name="state"
                          value={formData.state}
                          onChange={handleChange}
                          placeholder="Enter your State / Province"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mt-3">
                    <Col md={6}>
                      <Form.Group controlId="zipcode">
                        <Form.Control
                          type="text"
                          name="zipcode"
                          value={formData.zipcode}
                          onChange={handleChange}
                          placeholder="Enter your zipcode"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="country">
                        <Form.Control
                          as="select"
                          name="country"
                          value={formData.country}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select your country</option>
                          {Object.entries(Countries).map(
                            ([key, value], index) => (
                              <option key={index} value={key}>
                                {value}
                              </option>
                            )
                          )}
                        </Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* New Checkbox for Sending Details to Provider */}
                  <Form.Group
                    controlId="sendDetailsToProvider"
                    className="mt-3"
                  >
                    <Form.Check
                      type="checkbox"
                      id="sendDetailsCheckbox"
                      label="Would you like us to share your information with the selected drone company?"
                      checked={
                        formData.providerDetails[0]?.sendDetailsToProvider ||
                        false
                      }
                      onChange={handleSendDetailsChange}
                    />
                  </Form.Group>

                  <Form.Group controlId="Interested_in" className="mt-3">
                    <Form.Label>Interested in?</Form.Label>
                    <div>
                      {interestOptions.map((interest, index) => (
                        <Form.Check
                          key={index}
                          type="checkbox"
                          id={`interest-${index}`}
                          label={interest}
                          value={interest}
                          checked={formData.Interested_in.includes(interest)}
                          onChange={handleCheckboxChange}
                        />
                      ))}
                    </div>
                  </Form.Group>
                  <Form.Group controlId="message" className="mt-3">
                    <Form.Control
                      as="textarea"
                      name="message"
                      placeholder="Question, Comments, and/or Scope of Project (optional)"
                      value={formData.message}
                      onChange={handleChange}
                      rows={4}
                    />
                  </Form.Group>

                  {/* Terms of Service Checkbox */}
                  <Form.Group controlId="terms_and_conditions" className="mt-3">
                    <Form.Check
                      type="checkbox"
                      id="termsCheckbox"
                      label={<span>I accept the </span>}
                      checked={formData.terms_and_conditions}
                      onChange={handleTermsChange}
                    />
                    <span
                      onClick={() => setShowTermsModal(true)}
                      style={{
                        color: "blue",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                    >
                      Terms of Service
                    </span>
                    {showError && (
                      <p style={{ color: "red" }}>
                        Please accept the Terms of Service to proceed.
                      </p>
                    )}
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                    className="submit-button mt-4"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </Form>

                {isSubmitting && (
                  <div className="loader-overlay">
                    <ThreeDots color="#050505" height={80} width={80} />
                  </div>
                )}
              </div>

              {responseMessage && (
                <div className="mt-3 text-center">
                  <p>{responseMessage}</p>
                </div>
              )}
            </>
          ) : (
            <div className="text-center">
              <h2>Thank You!</h2>
              <p>Our sales team will contact you shortly.</p>
              <p>
                You will be redirected to the home page in {countdown} seconds.
              </p>
            </div>
          )}
        </Col>
      </Row>

      {/* Modal for Terms of Service */}
      <Modal show={showTermsModal} onHide={() => setShowTermsModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Terms of Service </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Effective Date: October 23, 2024</p>
          <p>1. Introduction </p>
          <p>
            Welcome to GeoWGS84 Corp ("GeoWGS84," "we," "us," or "our"). By
            accessing or using our services, including our website, software,
            and any related products or services (collectively, the "Services"),
            you agree to comply with and be bound by these Terms of Service
            ("Terms"). Please read these Terms carefully before using our
            Services. If you do not agree to these Terms, you may not use our
            Services.
          </p>
          <p>2. Services </p>
          <p>
            GeoWGS84 provides geospatial data, mapping solutions, and related
            services to our clients ("Client" or "you"). The specifics of the
            Services we provide will be detailed in individual agreements or
            contracts with our clients.
          </p>
          <p>3. Use of Services </p>
          <p>
            - Eligibility: To use our Services, you must be at least 18 years
            old and capable of forming a legally binding contract. By using our
            Services, you represent and warrant that you meet these
            requirements.
          </p>
          <p>
            - Account Responsibilities: You are responsible for maintaining the
            confidentiality of your account credentials and for all activities
            that occur under your account. Notify us immediately if you become
            aware of any unauthorized use of your account.
          </p>
          <p>
            - Permitted Use: You agree to use our Services only for lawful
            purposes and in accordance with these Terms. You may not use our
            Services for any illegal or unauthorized activities, including but
            not limited to violating intellectual property rights or
            transmitting harmful or disruptive content.
          </p>
          <p>4. Intellectual Property </p>
          <p>
            - Ownership: All intellectual property rights in and to the
            Services, including but not limited to software, designs, logos, and
            content, are owned by GeoWGS84 or its licensors. You may not copy,
            modify, distribute, or create derivative works based on our
            intellectual property without our prior written consent.
          </p>
          <p>
            - License: Subject to your compliance with these Terms, we grant you
            a limited, non-exclusive, non-transferable license to use our
            Services for your personal or internal business purposes.
          </p>
          <p>5. Fees and Payment </p>
          <p>
            - Fees: The fees for our Services will be outlined in individual
            agreements or contracts. You agree to pay all fees as specified and
            in accordance with the payment terms agreed upon.
          </p>
          <p>
            - Payment Terms: Payments are due in accordance with the terms
            specified in the applicable agreement or contract. Late payments may
            incur interest and collection fees.
          </p>
          <p>6. Termination </p>
          <p>
            - Termination by You: You may terminate your use of our Services at
            any time by providing us with written notice. If a contract is in
            place you are obligated to the contract and cannot terminate it
            without an agreement with GeoWGS84.
          </p>
          <p>
            - Termination by Us: We reserve the right to terminate or suspend
            your access to our Services, with or without cause, at our sole
            discretion. If we terminate your access for breach of these Terms,
            we may retain any fees paid.
          </p>
          <p>7. Limitation of Liability </p>
          <p>
            To the fullest extent permitted by law, GeoWGS84 shall not be liable
            for any indirect, incidental, special, or consequential damages
            arising out of or in connection with your use of our Services,
            including but not limited to loss of profits, data, or goodwill.</p>
            <p>All data acquired and processed will be the responsibility of GeoWGS84
            business partners. Our business partners are responsible for meeting
            the project specifications for data collection and processing and
            turnaround times.</p>
          
          <p>8. Indemnification </p>
          <p>
            You agree to indemnify, defend, and hold harmless GeoWGS84 and its
            affiliates, officers, directors, employees, and agents from and
            against any claims, liabilities, damages, losses, or expenses
            arising out of or related to your use of our Services, your
            violation of these Terms, or your infringement of any third-party
            rights.
          </p>
          <p>9. Changes to Terms </p>
          <p>
            We may modify these Terms from time to time. We will notify you of
            any material changes by posting the updated Terms on our website.
            Your continued use of our Services after such changes constitutes
            your acceptance of the revised Terms.
          </p>
          <p>10. Governing Law </p>
          <p>
            These Terms shall be governed by and construed in accordance with
            the laws of the State of Colorado, without regard to its conflict of
            law principles. Any disputes arising under or in connection with
            these Terms shall be resolved exclusively in the courts located in
            Colorado.
          </p>
          <p>11. Contact Us </p>
          <p>
            If you have any questions or concerns about these Terms, please
            contact us at:{" "}
          </p>
          <p>
            GeoWGS84 Corp <br />
            11973 S Longs Bluff Ln <br />
            Parker, CO, 80134
            <br />
            (720) 702-4849
            <br />
            info@geowgs84.com
          </p>
          <p>--- </p>
          <p>12. Miscellaneous </p>
          <p>
            - Entire Agreement: These Terms constitute the entire agreement
            between you and GeoWGS84 regarding your use of our Services and
            supersede all prior agreements and understandings.
          </p>
          <p>
            - Severability: If any provision of these Terms is found to be
            invalid or unenforceable, the remaining provisions will remain in
            full force and effect.
          </p>
          <p>
            - No Waiver: Our failure to enforce any right or provision of these
            Terms will not be deemed a waiver of such right or provision.
          </p>
          <p>Thank you for choosing GeoWGS84 Corp! </p>
          <p></p>
          <p></p>
        </Modal.Body>
        <Modal.Footer>
          <div>
          <button onClick={downloadPDF}>Download Terms of Service</button></div>
         <div> <Button variant="secondary" onClick={() => setShowTermsModal(false)}>
            Close
          </Button>
          </div>
          
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export { ContactSalesForm };
